import { useField } from 'formik';

import { Text } from '../../../cdl/Text/Text';
import { FormikFormattedNumberInput } from '../../FormattedNumberInput/FormikFormattedNumberInput';
import { formatNumber } from '../../helpers/formatNumber.helper';
import { Characters } from '../../helpers/unicode.helper';
import { useRole } from '../../hooks/useRole';
import { isUnitSizeEditable } from '../components/isUnitSizeEditable';

interface UnitSizeDisplayProps {
    name: string;
    editable: boolean;
}

export const UnitSizeDisplay = (props: UnitSizeDisplayProps) => {
    const role = useRole();
    const [field] = useField(props.name);
    const item = field.value;

    if (
        !isUnitSizeEditable({
            editable: props.editable,
            isCustomer: role.isCustomer(),
            item,
        })
    ) {
        const unitSize = item.unitSize
            ? formatNumber({ number: item.unitSize, maximumFractionDigits: 3 })
            : Characters.EN_DASH;

        return <Text variant="small">{unitSize}</Text>;
    }

    return (
        <FormikFormattedNumberInput
            name={`${props.name}.unitSize`}
            disabled={item.deleted}
            decimalsLimit={3}
            allowNegativeValue={false}
        />
    );
};
